import axios from 'axios';
// `config` se importa directo y NO por el contenedor: `inversify-config` importa este modulo, asi
// que pedirselo cierra un ciclo. Es el mismo objeto en los dos casos, porque el contenedor lo
// registra con `toConstantValue(config)`.
import config from 'src/config/app-config';
import { EstimatedMonthlyIncomeResult, PayrollEstimateRequest, VacationDaysCalculationInfo } from './types';
import querystring from 'query-string';
import { isNullOrWhiteSpaces } from 'src/shared/utils/strings';

export class PaymentsConstantsConfigApiService {
  protected _apiBaseUrl: string;
  constructor(version: string = 'v1') {
    const baseUrl = config.baseUrl;
    this._apiBaseUrl = `${baseUrl}/odata/${version}/PaymentsConstantsConfiguration`;
  }

  public async estimateMonthlyIncomeInfo(data: PayrollEstimateRequest): Promise<EstimatedMonthlyIncomeResult> {
    const parts: string[] = [];

    const pQs = querystring.stringify(data);
    if (!isNullOrWhiteSpaces(pQs)) parts.push(pQs);

    parts.push('$format=application/json;odata.metadata=none');

    let qs = '';

    if (parts.length > 0) {
      qs = parts.join('&');
      if (!qs.startsWith('?')) qs = '?' + qs;
    }

    const result = await axios.get<EstimatedMonthlyIncomeResult>(`${this._apiBaseUrl}/EstimateMonthlyIncomeBySalaryType${qs}`);

    return result?.data;
  }

  public async estimateVacationDaysAmount(data: VacationDaysCalculationInfo): Promise<number> {
    const parts: string[] = [];

    const pQs = querystring.stringify(data);
    if (!isNullOrWhiteSpaces(pQs)) parts.push(pQs);

    parts.push('$format=application/json;odata.metadata=none');

    let qs = '';

    if (parts.length > 0) {
      qs = parts.join('&');
      if (!qs.startsWith('?')) qs = '?' + qs;
    }

    const result = await axios.get<{ value: number }>(`${this._apiBaseUrl}/EstimateVacationDaysAmount${qs}`);

    return result?.data?.value ?? 0;
  }
}
